import { Schema, arrayOf } from 'normalizr'

export const agent = new Schema('agents')
export const arrayOfagents = arrayOf(agent)
